import {Student, StudentPayload} from './student'
import {InternshipCompany, InternshipCompanyPayload} from './internship-company'
import {File, FilePayload} from './file'

export interface InternshipPayload {
    IDPraktikum: number
    IDSchueler: number
    BetriebNr: number
    PrakAnfang: string
    PrakEnde: string
    BetriebName: string
    BetriebAdresse: string
    /* relations */
    student?: StudentPayload
    company?: InternshipCompanyPayload
    files?: FilePayload[]
}

export class Internship {

    IDPraktikum: number
    IDSchueler: number
    BetriebNr: number
    PrakAnfang: string
    PrakEnde: string
    BetriebName: string
    BetriebAdresse: string
    /* relations */
    student: Student
    company: InternshipCompany
    files: File[]

    constructor(data: InternshipPayload) {
        this.IDPraktikum = data.IDPraktikum
        this.IDSchueler = data.IDSchueler
        this.BetriebNr = data.BetriebNr
        this.PrakAnfang = data.PrakAnfang
        this.PrakEnde = data.PrakEnde
        this.BetriebName = data.BetriebName
        this.BetriebAdresse = data.BetriebAdresse
        this.student = new Student(data.student || <StudentPayload>{})
        this.company = new InternshipCompany(data.company || <InternshipCompanyPayload>{})
        this.files = [] as File[]
        data.files?.forEach((item: FilePayload) => {
            this.files.push(new File(item))
        })
    }

    fill(data: InternshipPayload): this {
        this.IDPraktikum = data.IDPraktikum
        this.IDSchueler = data.IDSchueler
        this.BetriebNr = data.BetriebNr
        this.PrakAnfang = data.PrakAnfang
        this.PrakEnde = data.PrakEnde
        this.BetriebName = data.BetriebName
        this.BetriebAdresse = data.BetriebAdresse
        this.student = new Student(data.student || <StudentPayload>{})
        this.company = new InternshipCompany(data.company || <InternshipCompanyPayload>{})
        this.files = [] as File[]
        data.files?.forEach((item: FilePayload) => {
            this.files.push(new File(item))
        })
        return this
    }

    payload(): InternshipPayload {
        return {
            IDPraktikum: this.IDPraktikum,
            IDSchueler: this.IDSchueler,
            BetriebNr: this.BetriebNr,
            PrakAnfang: this.PrakAnfang,
            PrakEnde: this.PrakEnde,
            BetriebName: this.BetriebName,
            BetriebAdresse: this.BetriebAdresse,
        }
    }
}
